type EngineClass =
  | "wpe"
  | "electron"
  | "blink-legacy"
  | "blink"
  | "webos"
  | "other";

/**
 * Classifies a user agent string into the closed set of engine classes used
 * as the `engine` metric tag. First match wins. Every named value maps to a
 * known fleet cohort, so anything unrecognized — including desktop browsers
 * and dev/test sessions — lands in "other".
 */
function classifyEngine(ua: string): EngineClass {
  // VC Electron frame cohort
  if (ua.includes("Electron/")) return "electron";
  // LG SmartTV — the fleet UA spells it "Web0S" (with a zero)
  if (ua.includes("Web0S") || ua.includes("webOS")) return "webos";
  // MR5 / WPE WebKit: Safari-style UA with no Chrome token
  if (
    ua.includes("AppleWebKit/605") &&
    ua.includes("Linux") &&
    ua.includes("Version/")
  ) {
    return "wpe";
  }
  // QtWebEngine kiosks (classic Matisse/MR4 today, MAD OS next): split
  // legacy/modern by the embedded Chrome version
  if (ua.includes("QtWebEngine")) {
    const chrome = /Chrome\/(\d+)/.exec(ua);
    if (chrome) return Number(chrome[1]) < 60 ? "blink-legacy" : "blink";
  }
  return "other";
}

// Page-lifetime constant, classified once at module load.
const engineClass = classifyEngine(
  typeof navigator === "undefined" ? "" : navigator.userAgent
);

export { classifyEngine, engineClass, type EngineClass };
